import { Skeleton, Stack } from "@mui/material";

export const ReminderListRowSkeleton = () => (
	<Stack direction="row" alignItems="center" gap={1.2}>
		<Skeleton
			variant="circular"
			width={20}
			height={20}
			sx={{ flexShrink: 0 }}
			animation="wave"
		/>
		<Stack flex={1} minWidth={0} gap={0.4}>
			<Skeleton variant="text" width="55%" height={18} animation="wave" />
			<Skeleton variant="text" width="40%" height={14} animation="wave" />
		</Stack>
		<Skeleton
			variant="circular"
			width={32}
			height={32}
			sx={{ flexShrink: 0 }}
			animation="wave"
		/>
	</Stack>
);
